export default __webpack_public_path__ + "static/media/image-chair-learn-w@2x.5929e723.webp";